import { render, staticRenderFns } from "./EHSTableHeader.vue?vue&type=template&id=701bb1ca&scoped=true&"
import script from "./EHSTableHeader.vue?vue&type=script&lang=js&"
export * from "./EHSTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./EHSTableHeader.vue?vue&type=style&index=0&id=701bb1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bb1ca",
  null
  
)

export default component.exports